import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import {
  getSettings as onGetSettings,
  updateSettings as onUpdateSettings,
  getRestrictedBrands as onGetRestrictedBrands,
  getRestrictedMeltables as onGetRestrictedMeltables,
  getRestrictedAsins as onGetRestrictedAsins,
  addRestrictedBrands as onAddRestrictedBrands,
  addRestrictedMeltables as onAddRestrictedMeltables,
  addRestrictedAsins as onAddRestrictedAsins,
  updateRestrictedBrands as onUpdateRestrictedBrands,
  updateRestrictedMeltables as onUpdateRestrictedMeltables,
  updateRestrictedAsins as onUpdateRestrictedAsins,
  deleteRestrictedBrands as onDeleteRestrictedBrands,
  deleteRestrictedMeltables as onDeleteRestrictedMeltables,
  deleteRestrictedAsins as onDeleteRestrictedAsins,
  getSubscriptionFrequencies as onGetSubscriptionFrequencies,
  updateSubscriptionFrequencyStatus as onUpdateSubscriptionFrequencyStatus,
} from "../../slices/thunks";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";
import { Link } from "react-router-dom";
import { Checkbox, Tooltip } from "@mui/material";

const Settings = () => {
  const dispatch = useDispatch();
  const [settings, setSettings] = useState();
  const [showAddMeltable, setShowAddMeltable] = useState(false);
  const [showAddBrand, setShowAddBrand] = useState(false);
  const [showAddAsin, setShowAddAsin] = useState(false);
  const [restrictionSource, setRestrictionSource] = useState(0);
  const [meltableAsin, setMeltableAsin] = useState("");
  const [brandName, setBrandName] = useState("");
  const [asinName, setAsinName] = useState("");

  const selectSettingsData = createSelector(
    (state) => state.Settings,
    (setting) => setting,
    (restrictedBrands) => restrictedBrands,
    (restrictedAsins) => restrictedAsins,
    (restrictedMeltables) => restrictedMeltables,
    (subscriptionFrequencies) => subscriptionFrequencies
  );

  const { setting, restrictedAsins, restrictedBrands, restrictedMeltables, subscriptionFrequencies } =
    useSelector(selectSettingsData);

  useEffect(() => {
    setSettings(setting);
  }, [setting]);

  const fetchSettings = async () => {
    // setIsLoading(true);
    dispatch(onGetSettings());
    const data = { source: restrictionSource };

    dispatch(onGetRestrictedAsins(data));
    dispatch(onGetRestrictedBrands(data));
    dispatch(onGetRestrictedMeltables(data));
    dispatch(onGetSubscriptionFrequencies());
  };

  const updateSettings = async () => {
    dispatch(onUpdateSettings(settings));
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setSettings({
      ...settings,
      [name]: type === "number" ? parseFloat(value) : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateSettings();
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
    const data = { source: restrictionSource };
    dispatch(onGetRestrictedAsins(data));
    dispatch(onGetRestrictedBrands(data));
    dispatch(onGetRestrictedMeltables(data));
  }, [restrictionSource]);

  const columnsMeltables = useMemo(
    () => [
      {
        id: "select-col",
        header: ({ table }) => (
          <Checkbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()} //or getToggleAllPageRowsSelectedHandler
          />
        ),
        cell: ({ row }) => (
          <Checkbox
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            onChange={row.getToggleSelectedHandler()}
          />
        ),
      },
      {
        header: "ASIN",
        accessorKey: "mel_ASIN",
        enableColumnFilter: false,
      },
      {
        header: "Status",
        accessorKey: "mel_status",
        enableColumnFilter: false,
        cell: (cell) => {
          return cell.getValue() === 0 ? (
            <span
              style={{ width: "100px" }}
              className="badge text-uppercase bg-success"
            >
              Active
            </span>
          ) : (
            <span
              style={{ width: "100px" }}
              className="badge text-uppercase bg-danger"
            >
              Inactive
            </span>
          );
        },
      },
      {
        header: "Action",
        cell: (cell) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn btn-soft-secondary btn-sm"
                tag="button"
              >
                <i className="ri-more-fill" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    const data = [
                      {
                        mel_id: cell.row.original.mel_id,
                        mel_ASIN: cell.row.original.mel_ASIN,
                        mel_status: cell.row.original.mel_status === 0 ? 1 : 0,
                      },
                    ];
                    dispatch(onUpdateRestrictedMeltables(data));
                  }}
                >
                  <i className="ri-arrow-left-right-fill align-bottom me-2 text-muted"></i>{" "}
                  Change status
                </DropdownItem>
                <DropdownItem
                  href="#"
                  onClick={() => {
                    const data = cell.row.original;
                    dispatch(
                      onDeleteRestrictedMeltables({ mel_id: data.mel_id })
                    );
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );
  const columnsAsins = useMemo(
    () => [
      {
        header: "ASIN",
        accessorKey: "rea_ASIN",
        enableColumnFilter: false,
      },
      {
        header: " ",
        cell: (cell) => {
          return (
            <Tooltip title="Delete">
              <Link
                to="#"
                className="text-primary d-inline-block"
                onClick={() => {
                  const data = cell.row.original;
                  dispatch(onDeleteRestrictedAsins({ rea_id: data.rea_id }));
                }}
              >
                <i className="ri-delete-bin-fill align-bottom me-2 text-danger"></i>
              </Link>
            </Tooltip>
          );
        },
      },
    ],
    []
  );
  const columnsBrands = useMemo(
    () => [
      {
        header: "Brand",
        accessorKey: "reb_name",
        enableColumnFilter: false,
      },
      {
        header: " ",
        cell: (cell) => {
          return (
            <Tooltip title="Delete">
              <Link
                to="#"
                className="text-primary d-inline-block"
                onClick={() => {
                  const data = cell.row.original;
                  dispatch(onDeleteRestrictedBrands({ reb_id: data.reb_id }));
                }}
              >
                <i className="ri-delete-bin-fill align-bottom me-2 text-danger"></i>
              </Link>
            </Tooltip>
          );
        },
      },
    ],
    []
  );

  const columnsFrequencies = useMemo(
    () => [
      {
        header: "Frequency",
        accessorKey: "sfr_frequency",
        enableColumnFilter: false,
        cell: (cell) => {
          const frequency = cell.getValue();
          return frequency.charAt(0).toUpperCase() + frequency.slice(1);
        },
      },
      {
        header: "Status",
        accessorKey: "sfr_status",
        enableColumnFilter: false,
        cell: (cell) => {
          const frequency = cell.row.original.sfr_frequency;
          const currentStatus = cell.getValue();
          const newStatus = currentStatus === 1 ? 0 : 1;
          const action = newStatus === 1 ? 'activate' : 'deactivate';
          
          return (
            <div className="d-flex align-items-center gap-2">
              {currentStatus === 1 ? (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase bg-success"
                >
                  Active
                </span>
              ) : (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase bg-danger"
                >
                  Inactive
                </span>
              )}
              <Tooltip title={`Click to ${action}`}>
                <Link
                  to="#"
                  className="text-primary d-inline-block"
                  onClick={() => {
                    if (window.confirm(
                      `Are you sure you want to ${action} the ${frequency} subscription frequency?`
                    )) {
                      dispatch(
                        onUpdateSubscriptionFrequencyStatus({
                          frequency: frequency,
                          status: newStatus,
                        })
                      );
                    }
                  }}
                >
                  <i className="ri-arrow-left-right-fill fs-5 text-muted"></i>
                </Link>
              </Tooltip>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Settings" pageTitle="Settings" />
        <Card className="p-4">
          <CardHeader>
            <h4>Set cost</h4>
            Manage and set FBA, FBM and eBay Prep Fee that will be added to
            analyzer tool import as per each sale channel.
          </CardHeader>
          <form
            className="needs-validation createfile-form mt-4"
            id="createfile-form"
            onSubmit={handleSubmit}
          >
            <div className="mb-4">
              <label htmlFor="file-input" className="form-label">
                FBA Prep Fee:
                <input
                  type="number"
                  name="ase_prepFeeFBA"
                  className="form-control"
                  value={settings?.ase_prepFeeFBA}
                  onChange={handleChange}
                  step="0.01"
                />
              </label>
            </div>
            <div className="mb-4 ">
              <label htmlFor="file-input" className="form-label">
                FBM Prep Fee:
                <input
                  type="number"
                  name="ase_prepFeeFBM"
                  className="form-control"
                  value={settings?.ase_prepFeeFBM}
                  onChange={handleChange}
                  step="0.01"
                />
              </label>
            </div>
            <div className="mb-4">
              <label htmlFor="file-input" className="form-label">
                eBay Prep Fee :
                <input
                  type="number"
                  name="ase_prepFeeEbay"
                  className="form-control"
                  value={settings?.ase_prepFeeEbay}
                  onChange={handleChange}
                  step="0.01"
                />
              </label>
            </div>
            <div className="mb-4">
              <label htmlFor="file-input" className="form-label">
                Walmart Prep Fee:
                <input
                  type="number"
                  name="ase_prepFeeWalmart"
                  className="form-control"
                  value={settings?.ase_prepFeeWalmart}
                  onChange={handleChange}
                  step="0.01"
                />
              </label>
            </div>
            <div className="mb-4">
              <label htmlFor="file-input" className="form-label">
                Liquidations Prep Fee:
                <input
                  type="number"
                  name="ase_prepFeeLiquidations"
                  className="form-control"
                  value={settings?.ase_prepFeeLiquidations}
                  onChange={handleChange}
                  step="0.01"
                />
              </label>
            </div>
            <div className="mb-4">
              <label htmlFor="file-input" className="form-label">
                Other Prep Fee:
                <input
                  type="number"
                  name="ase_prepFeeAny"
                  className="form-control"
                  value={settings?.ase_prepFeeAny}
                  onChange={handleChange}
                  step="0.01"
                />
              </label>
            </div>
            <div className="mb-4">
              <label htmlFor="warning-message" className="form-label">
                Warning message:
                <input
                  type="text"
                  name="ase_warning"
                  id="warning-message"
                  className="form-control"
                  value={settings?.ase_warning || ""}
                  onChange={handleChange}
                />
                <div className="form-text">
                  Enter a message to show every user after login. Leave empty for no message.
                </div>
              </label>
            </div>
            <div className="mb-4">
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </Card>
        <Card className="p-4 mt-4 ">
          <CardHeader>
            <h2>Restrictions</h2>
            Manage and set retricted meltables, brands and ASIN for:
            <div className="col-xl-3 col-sm-12 flex-wrap">
              <select
                label="Restriction Source"
                id="restriction-source"
                className="form-select"
                value={restrictionSource}
                onChange={(e) => setRestrictionSource(e.target.value)}
              >
                <option value={0}>Amazon</option>
                <option value={1}>Walmart</option>
                <option value={2}>eBay</option>
                <option value={3}>Other</option>
                <option value={5}>Liquidations</option>
              </select>
            </div>
          </CardHeader>
          <CardBody>
            <Row className="justify-content-between">
              <div className="mb-4 col-xl-3 col-sm-12">
                <div className="justify-content-between d-flex align-items-center">
                  <label htmlFor="meltables-input" className="form-label">
                    <h3>Restricted Meltables</h3>
                  </label>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm ms-2"
                    onClick={() => {
                      setShowAddMeltable(!showAddMeltable);
                    }}
                  >
                    {showAddMeltable ? "Close" : "Add New"}
                  </button>
                </div>
                {showAddMeltable && (
                  <div className="d-flex">
                    <input
                      type="text"
                      id="meltables-input"
                      className="form-control"
                      placeholder="Add new meltable"
                      value={meltableAsin || ""}
                      onChange={(e) => setMeltableAsin(e.target.value)}
                    />
                    <button
                      disabled={!meltableAsin || meltableAsin === ""}
                      type="button"
                      className="btn btn-success ms-2"
                      onClick={() => {
                        dispatch(
                          onAddRestrictedMeltables({
                            mel_ASIN: meltableAsin,
                            mel_source: restrictionSource,
                          })
                        );
                        setMeltableAsin("");
                        setShowAddMeltable(false);
                      }}
                    >
                      Save
                    </button>
                  </div>
                )}
                <TableContainer
                  columns={columnsMeltables}
                  data={restrictedMeltables || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive mb-1"
                  tableClass="mb-0 align-middle table-borderless"
                  theadClass="table-light text-muted"
                  isProductsFilter={true}
                  SearchPlaceholder="Search Meltables..."
                  manualPagination={false}
                  NoRowLabel="No Meltables found"
                  bulkActions={true}
                  changeStatus={(rows) => {
                    dispatch(onUpdateRestrictedMeltables(rows));
                  }}
                />
              </div>

              <div className="mb-4 col-xl-3 col-sm-12">
                <div className="justify-content-between d-flex align-items-center">
                  <label htmlFor="brands-input" className="form-label">
                    <h3>Restricted Brands</h3>
                  </label>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm ms-2"
                    onClick={() => {
                      setShowAddBrand(!showAddBrand);
                    }}
                  >
                    {showAddBrand ? "Close" : "Add New"}
                  </button>
                </div>
                {showAddBrand && (
                  <div className="d-flex">
                    <input
                      type="text"
                      id="meltables-input"
                      className="form-control"
                      placeholder="Add new brand"
                      value={brandName || ""}
                      onChange={(e) => setBrandName(e.target.value)}
                    />
                    <button
                      disabled={!brandName || brandName === ""}
                      type="button"
                      className="btn btn-success ms-2"
                      onClick={() => {
                        dispatch(
                          onAddRestrictedBrands({
                            reb_name: brandName,
                            reb_source: restrictionSource,
                          })
                        );
                        setBrandName("");
                        setShowAddBrand(false);
                      }}
                    >
                      Save
                    </button>
                  </div>
                )}
                <TableContainer
                  columns={columnsBrands}
                  data={restrictedBrands || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive mb-1"
                  tableClass="mb-0 align-middle table-borderless"
                  theadClass="table-light text-muted"
                  isProductsFilter={true}
                  SearchPlaceholder="Search Brands..."
                  manualPagination={false}
                  NoRowLabel="No brands found"
                />
              </div>
              <div className="mb-4 col-xl-3 col-sm-12">
                <div className="justify-content-between d-flex align-items-center">
                  <label htmlFor="asins-input" className="form-label">
                    <h3>Restricted ASINs </h3>
                  </label>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm ms-2"
                    onClick={() => {
                      setShowAddAsin(!showAddAsin);
                    }}
                  >
                    {showAddAsin ? "Close" : "Add New"}
                  </button>
                </div>
                {showAddAsin && (
                  <div className="d-flex">
                    <input
                      type="text"
                      id="meltables-input"
                      className="form-control"
                      placeholder="Add new ASIN"
                      value={asinName || ""}
                      onChange={(e) => setAsinName(e.target.value)}
                    />
                    <button
                      disabled={!asinName || asinName === ""}
                      type="button"
                      className="btn btn-success ms-2"
                      onClick={() => {
                        dispatch(
                          onAddRestrictedAsins({
                            rea_ASIN: asinName,
                            rea_source: restrictionSource,
                          })
                        );
                        setAsinName("");
                        setShowAddAsin(false);
                      }}
                    >
                      Save
                    </button>
                  </div>
                )}

                <TableContainer
                  columns={columnsAsins}
                  data={restrictedAsins || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive mb-1"
                  tableClass="mb-0 align-middle table-borderless"
                  theadClass="table-light text-muted"
                  isProductsFilter={true}
                  SearchPlaceholder="Search ASIN..."
                  manualPagination={false}
                  NoRowLabel="No ASINs found"
                />
              </div>
            </Row>
          </CardBody>
        </Card>

        {/* Subscription Section */}
        <Card className="p-4 mt-4">
          <CardHeader>
            <h4>Subscription</h4>
            Manage subscription settings including trial period and billing frequency options.
          </CardHeader>
          <CardBody>
            <Row>
              <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                >
                  <h5 className="mb-3">Trial Period</h5>
                  <div className="mb-4">
                    <label htmlFor="trial-days" className="form-label">
                      Trial Days:
                      <input
                        type="number"
                        name="ase_trialDays"
                        id="trial-days"
                        className="form-control"
                        value={settings?.ase_trialDays || 0}
                        onChange={handleChange}
                        min="0"
                        step="1"
                      />
                      <div className="form-text">
                        Number of trial days for new subscriptions. Set to 0 for no trial period.
                      </div>
                    </label>
                  </div>
                  <div className="mb-4">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
                <h5 className="mb-3">Subscription Frequencies</h5>
                <p className="text-muted mb-3">Manage available subscription billing frequency options that users can select during registration.</p>
                <div className="mt-3">
                  <TableContainer
                    columns={columnsFrequencies}
                    data={subscriptionFrequencies || []}
                    isGlobalFilter={true}
                    customPageSize={10}
                    divClass="table-responsive mb-1"
                    tableClass="mb-0 align-middle table-borderless"
                    theadClass="table-light text-muted"
                    isProductsFilter={true}
                    SearchPlaceholder="Search frequency..."
                    manualPagination={false}
                    NoRowLabel="No subscription frequencies found"
                  />
                </div>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Settings;
